import { missingFrom } from '@/features/Auth/machine/completion'
import { queryClient } from '@/services/api/queryClient'
import { QueryKeys } from '@/services/api/session/queryKeys'

const TIMEOUT = 5 * 60 * 1000

/**
 * Resolves once the profile has everything the product needs, or false if it gives up.
 *
 * The gate used to wait on `ensureProfileDetailsTopic`, published from exactly one place —
 * the onboarding modal, at the end of its own transition. Any other way of filling the last
 * gap left the waiter hanging, because nothing else knew it had to announce.
 *
 * This watches the query cache instead, so a gap filled by any screen or modal resolves it.
 * See EPIC-005.
 */
export function awaitProfileComplete(timeout = TIMEOUT): Promise<boolean> {
  const complete = () => {
    const profile = QueryKeys.me.getData()

    return !!profile?.id && missingFrom(profile).length === 0
  }

  if (complete()) return Promise.resolve(true)

  return new Promise(resolve => {
    const settle = (value: boolean) => {
      clearTimeout(timer)
      unsubscribe()
      resolve(value)
    }

    const timer = setTimeout(() => settle(false), timeout)
    const unsubscribe = queryClient.client.getQueryCache().subscribe(() => {
      if (complete()) settle(true)
    })
  })
}
